import { useSyncExternalStore } from "react";
const event = "topiqz:navigate";
export function navigate(url: string, replace = false) {
  window.history[replace ? "replaceState" : "pushState"](null, "", url);
  window.dispatchEvent(new Event(event));
}
export function useLocation() {
  return useSyncExternalStore((notify) => {
    window.addEventListener("popstate", notify);
    window.addEventListener(event, notify);
    return () => { window.removeEventListener("popstate", notify); window.removeEventListener(event, notify); };
  }, () => window.location.pathname + window.location.search);
}
export function storyUrl(storyId?: string) {
  return `${window.location.origin}/reading${storyId ? `?story=${encodeURIComponent(storyId)}` : ""}`;
}
export function pushStoryUrl(storyId?: string) {
  const url = new URL(window.location.href);
  if (storyId) url.searchParams.set("story", storyId);
  else url.searchParams.delete("story");
  if (url.pathname.startsWith("/play/")) url.searchParams.set("activity", "reading");
  // The reading screen already owns this state; a history entry makes browser Back work.
  if (url.href !== window.location.href) window.history.pushState(null, "", url);
}
// Only these public destinations may survive the parent OAuth round trip.
export function readingReturnPath(value: string | null) {
  if (!value || !value.startsWith("/") || value.startsWith("//")) return null;
  const url = new URL(value, window.location.origin);
  if (url.origin !== window.location.origin || !["/reading", "/kids"].includes(url.pathname)) return null;
  const id = url.searchParams.get("story");
  if (id && !/^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i.test(id)) return null;
  const params = new URLSearchParams();
  if (url.pathname === "/kids") {
    const activity = url.searchParams.get("activity");
    if (activity === "reading" || activity === "vocabulary") params.set("activity", activity);
    if (activity === "reading" && id) params.set("story", id);
  } else if (id) params.set("story", id);
  if (url.pathname === "/reading" || params.get("activity") === "reading") copyReadingLanguage(url.searchParams, params);
  return url.pathname + (params.size ? `?${params}` : "");
}
export function rememberReadingReturn() {
  const path = readingReturnPath(window.location.pathname + window.location.search);
  if (path) sessionStorage.setItem("reading-return", path);
  else sessionStorage.removeItem("reading-return");
}
export function childActivityUrl(token: string, search = window.location.search) {
  const params = new URLSearchParams(search);
  const target = new URLSearchParams();
  if (params.get("activity") === "reading") {
    target.set("activity", "reading");
    copyReadingLanguage(params, target);
    if (params.get("story")) target.set("story", params.get("story")!);
  }
  return `/play/${encodeURIComponent(token)}${target.size ? `?${target}` : ""}`;
}
export function childPickerUrl(activity: "reading" | "vocabulary") {
  const params = new URLSearchParams({ activity });
  if (activity === "reading") copyReadingLanguage(new URLSearchParams(window.location.search), params);
  const story = new URLSearchParams(window.location.search).get("story");
  if (activity === "reading" && story) params.set("story", story);
  return `/kids?${params}`;
}

function copyReadingLanguage(source: URLSearchParams, target: URLSearchParams) {
  const language = source.get("language");
  if (language === "en" || language === "he") target.set("language", language);
}
